import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { useEffect } from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
var CHECKOUT_SCRIPT = "https://checkout-web-components.checkout.com/index.js";
function useCheckoutDotComHook(_ref) {
  var divSelector = _ref.divSelector,
    paymentSession = _ref.paymentSession,
    events = _ref.events,
    template = _ref.template,
    internvalTimeoutSeconds = _ref.internvalTimeoutSeconds;
  var lang = useLang();
  function init() {
    var script = document.createElement("script");
    script.src = CHECKOUT_SCRIPT;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    script.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _process$env$RAZZLE_C;
      var checkout, flowComponent;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return CheckoutWebComponents({
              publicKey: process.env.RAZZLE_CHECKOUT_PUBLIC_KEY_MADA,
              environment: (_process$env$RAZZLE_C = process.env.RAZZLE_CHECKOUT_ENV) !== null && _process$env$RAZZLE_C !== void 0 ? _process$env$RAZZLE_C : "sandbox",
              locale: lang + "-SA",
              paymentSession: paymentSession,
              onPaymentCompleted: events.on_completed,
              onSubmit: function () {
                var _onSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_self) {
                  var success;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.n) {
                      case 0:
                        _context.n = 1;
                        return events.on_initiating();
                      case 1:
                        success = _context.v;
                        if (!success) {
                          location.reload();
                        }
                      case 2:
                        return _context.a(2);
                    }
                  }, _callee);
                }));
                function onSubmit(_x) {
                  return _onSubmit.apply(this, arguments);
                }
                return onSubmit;
              }()
            });
          case 1:
            checkout = _context2.v;
            flowComponent = checkout.create("flow");
            flowComponent.mount(document.querySelector(divSelector));
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
  }
  useEffect(function () {
    var interval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var isReservedOrPaid;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return events.on_initiating();
          case 1:
            isReservedOrPaid = _context3.v;
            if (!isReservedOrPaid) {
              location.reload();
            }
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    })), internvalTimeoutSeconds * 1000);
    init();
    return function () {
      return clearInterval(interval);
    };
  }, []);
}
export default useCheckoutDotComHook;